(() => {
  class SatanReviewRotator extends HTMLElement {
    connectedCallback() {
      if (this.dataset.rotatorReady === 'true') return;
      this.dataset.rotatorReady = 'true';
      this.items = [...this.querySelectorAll('[data-review-item]')];
      this.index = Math.max(0, this.items.findIndex((item) => item.classList.contains('is-active')));
      this.intervalMs = Math.max(30000, Number.parseInt(this.dataset.interval || '30000', 10));
      this.style.setProperty('--sr-review-duration', `${this.intervalMs}ms`);
      if (this.items.length < 2) return;
      this.timer = window.setInterval(() => this.show((this.index + 1) % this.items.length), this.intervalMs);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    show(nextIndex) {
      const current = this.items[this.index];
      const next = this.items[nextIndex];
      if (!current || !next || current === next) return;
      this.classList.add('is-changing');
      current.classList.remove('is-active');
      current.setAttribute('aria-hidden', 'true');
      next.classList.add('is-active');
      next.setAttribute('aria-hidden', 'false');
      this.index = nextIndex;
      window.setTimeout(() => this.classList.remove('is-changing'), 700);
      const progress = this.querySelector('[data-review-progress]');
      if (progress) {
        progress.style.animation = 'none';
        void progress.offsetWidth;
        progress.style.animation = '';
      }
    }
  }

  if (!customElements.get('satan-review-rotator')) customElements.define('satan-review-rotator', SatanReviewRotator);
})();